import React from 'react';
import PropTypes from 'prop-types';
import toPairs from 'lodash/toPairs';
import {
  FormLabel, Select, MenuItem, FormControl,
} from '@mui/material';
import { CategoryOrErrorCode } from '../../lib/utils';

const styles = {
  formLabel: {
    textAlign: 'center',
    width: '100%',
  },
};

class CategoryErrorCodeSelect extends React.Component {
  constructor(props) {
    super(props);
    const { value } = props;

    this.state = {
      selectedCategoryOrErrorCode: value,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { handleChange } = this.props;
    const stateUpdate = { [event.target.name]: event.target.value };
    this.setState(stateUpdate);

    handleChange(event.target.value);
  }

  render() {
    const { disabled } = this.props;
    const { selectedCategoryOrErrorCode } = this.state;

    return (
      <FormControl component="fieldset" style={{ width: '100%' }}>
        <FormLabel component="legend" style={styles.formLabel}>
          Category or Error Code
        </FormLabel>
        <Select
          displayEmpty
          disabled={disabled}
          style={{ width: '100%' }}
          onChange={this.handleChange}
          value={selectedCategoryOrErrorCode}
          variant="standard"
          inputProps={{
            name: 'selectedCategoryOrErrorCode',
            id: 'category-error-code-picker',
          }}
        >
          {CategoryOrErrorCode
            && toPairs(CategoryOrErrorCode).map(([key, name]) => (
              <MenuItem value={name} key={key}>
                {name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}
CategoryErrorCodeSelect.defaultProps = {
  value: '',
  disabled: false,
};
CategoryErrorCodeSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
};

export default CategoryErrorCodeSelect;
